import { render, staticRenderFns } from "./DictItemSelect.vue?vue&type=template&id=27e5b26b&scoped=true"
import script from "./DictItemSelect.vue?vue&type=script&lang=js"
export * from "./DictItemSelect.vue?vue&type=script&lang=js"
import style0 from "./DictItemSelect.vue?vue&type=style&index=0&id=27e5b26b&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e5b26b",
  null
  
)

export default component.exports